module.exports = __webpack_public_path__ + "img/20180815_150347_085.e62b9668.jpg";